import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Modal } from "@opensea/ui-kit";
import { ItemOwnersModalFragment } from "./ItemOwnersModal.fragment";
import { ItemOwnersModalContent } from "./ItemOwnersModalContent";
export function ItemOwnersModal(t0) {
  const $ = _c(10);
  let itemKey;
  let props;
  if ($[0] !== t0) {
    ({
      item: itemKey,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = itemKey;
    $[2] = props;
  } else {
    itemKey = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== itemKey) {
    t1 = readFragment(ItemOwnersModalFragment, itemKey);
    $[3] = itemKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const item = t1;
  let t2;
  if ($[5] !== item) {
    t2 = <ItemOwnersModalContent item={item} />;
    $[5] = item;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== t2) {
    t3 = <Modal content={t2} {...props} />;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}